import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../../actions/search';
import {fileMetaDataValueFetchData, fileMetaDataCategoryFetchData} from '../../../actions/fileData'
import Loadable from 'react-loading-overlay/lib/LoadingOverlay'
import Loader from '../../../components/Loader';
import { setSearchScope } from '../../../helpers';
class Overview extends Component {

	constructor(props,context) {
        super(props,context);

        this.additionalColumns = [
        {
            Header: 'Actief',
            accessor: 'is_active',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        }, {
            Header: 'Kan gebruikt worden bij filter',
            accessor: 'is_searchable',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        }, {
            Header: 'Is een vrij invoerveld?',
            accessor: 'is_text',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        }, {
            Header: 'Is een datumveld?',
            accessor: 'is_date',
            Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
        },
            {
                Header: 'Beschikbaar in rapportage?',
                accessor: 'in_reports',
                Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
            }, {
            Header: 'Aanpassen',
            accessor: 'id',
            Cell: props => <span><a href={'/#/filemetadatacategory/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-pencil"></i> Bewerken</a></span>
        }
        ]

        this.columns = false;

    }

    componentDidUpdate(prevProps) {
		if ( JSON.stringify(prevProps.fileMetaDataCategory) !== JSON.stringify(this.props.fileMetaDataCategory) ) {
            this.props.updateSearchData(this.props.fileMetaDataCategory.data)
            this.columns = this.props.fileMetaDataCategory.columns
        }
    }

	componentWillMount() {
		setSearchScope('fileMetaDataCategory');
        if(this.props.clientPath.clientPath) {
			this.props.updateSearchData(this.props.fileMetaDataCategory.data)
            this.props.fileMetaDataCategoryFetchData(this.props.clientPath.clientPath)
			this.columns = this.props.fileMetaDataCategory.columns
        }

  	}

	render() {

        const filterValues = {
            isActive : {
                name: 'Is Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '1'
            },
            isNotActive : {
                name: 'Niet Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '0'
            }
        }
        return (

            <Card>
				<CardHeader>
				{this.props.fileMetaDataCategory.data ? <Search filters={filterValues} data={this.props.fileMetaDataCategory.data} keys_to_filter={['name']}/> : null }
				</CardHeader>
                <CardBody>
                    <CardTitle><i className="fa fa-align-justify"></i> Metadata categorie overzicht</CardTitle>
                    {this.columns ? <DataTable additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.props.fileMetaDataCategory.data} columns={this.columns} /> :
                    <Loader /> }
                </CardBody>
            </Card>

        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
        fileMetaDataCategory: state.FileMetaDataCategoryReducer,
        searchData: state.SearchDataReducer,
        clientPath: state.clientPathReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        fileMetaDataCategoryFetchData: (url) => dispatch(fileMetaDataCategoryFetchData(url + '/api/files/action/getFileMetaDataCategories')),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview)



// WEBPACK FOOTER //
// ./src/views/Filemetadatacategory/Overview/index.js